import { Rout_to } from './Rout'
import { Rout_create } from './Rout.create'

export interface Rout_UserPageRoutesArgs {
    User_Page: React.FunctionComponent<unknown>
}

export const Rout_UserPageRoutes = (args: Rout_UserPageRoutesArgs) => [Rout_create('/user/:userId', args.User_Page)]

export function Rout_toUserPage(userId: number) {
    Rout_to(`/user/${userId}`)
}
